import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2a4183e6")

_pushScopeId("data-v-2a4183e6")
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header card-p" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = { class: "card-label fw-bolder fs-3" }
const _hoisted_5 = { class: "card-body p-0" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "fw-bold d-block fs-7 custom" }
const _hoisted_10 = { class: "custom" }
const _hoisted_11 = {
  key: 0,
  class: "badge badge-light-primary"
}
const _hoisted_12 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_13 = { class: "custom" }
const _hoisted_14 = {
  key: 0,
  class: "badge badge-light-primary"
}
const _hoisted_15 = {
  key: 1,
  class: "badge badge-light-primary"
}
const _hoisted_16 = {
  key: 2,
  class: "badge badge-light-danger"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("button", {
  class: "action-btn",
  type: "button",
  id: "action-trigger",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" })
], -1)
const _hoisted_18 = {
  class: "dropdown-menu dropdown-menu-end action-dropdown",
  "aria-labelledby": "action-trigger"
}
const _hoisted_19 = { class: "menu-item-wrapper" }
const _hoisted_20 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-clipboard-list" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loader,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("h3", _hoisted_3, [
        _createVNode("span", _hoisted_4, _toDisplayString(`${_ctx.$t('message.LATEST_ORDERS')}`), 1)
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_Table, {
          columns: _ctx.columns,
          rows: _ctx.orders,
          padding: 5
        }, {
          "cell-name": _withId(({row:item}) => [
            (item?.customer)
              ? (_openBlock(), _createBlock("div", _hoisted_7, _toDisplayString(item?.customer?.user?.name), 1))
              : (_openBlock(), _createBlock("div", _hoisted_8, _toDisplayString(item?.name), 1))
          ]),
          "cell-status": _withId(({row:item}) => [
            _createVNode("span", _hoisted_9, _toDisplayString(JSON.parse(item?.order_status?.status)[_ctx.system_locale]?.name) + " " + _toDisplayString(item?.order_status?.id == 4 ? (item?.order_payment != null ? '(Paid)' : '(Failed)') : ''), 1)
          ]),
          "cell-economic": _withId(({row:item}) => [
            _createVNode("div", _hoisted_10, [
              (item?.economic_order_id != null)
                ? (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString(_ctx.$t('message.SENT')), 1))
                : (_openBlock(), _createBlock("span", _hoisted_12, _toDisplayString(_ctx.$t('message.NOT_SENT')), 1))
            ])
          ]),
          "cell-shipment": _withId(({row:item}) => [
            _createVNode("div", _hoisted_13, [
              (item?.order_status_id == 6)
                ? (_openBlock(), _createBlock("span", _hoisted_14, _toDisplayString(_ctx.$t('message.SENT')), 1))
                : (item?.order_status_id == 10)
                  ? (_openBlock(), _createBlock("span", _hoisted_15, _toDisplayString(_ctx.$t('message.READY_FOR_SHIPMENT')), 1))
                  : (_openBlock(), _createBlock("span", _hoisted_16, _toDisplayString(_ctx.$t('message.NOT_SENT')), 1))
            ])
          ]),
          "cell-total": _withId(({row:item}) => [
            _createTextVNode(_toDisplayString(JSON.parse(item.order_totals)?.total?.value), 1)
          ]),
          "cell-actions": _withId(({row:item}) => [
            _hoisted_17,
            _createVNode("div", _hoisted_18, [
              _createVNode("div", _hoisted_19, [
                (_ctx.$can('view_order_detail'))
                  ? (_openBlock(), _createBlock("div", _hoisted_20, [
                      _createVNode("a", {
                        onClick: ($event: any) => (_ctx.handleView(item)),
                        class: "menu-link me-1"
                      }, [
                        _hoisted_21,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('message.VIEW')), 1)
                      ], 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }, 8, ["columns", "rows"])
      ])
    ])
  ]))
})